import { gql } from '@apollo/client'
import { CORE_USER_FIELDS } from './fragments/user'

export const UPDATE_USER = gql`
  ${CORE_USER_FIELDS}
  mutation updateUser(
    $firstName: String
    $lastName: String
    $phoneNumber: String
    $photo: Upload
    $password: String
    $currentPassword: String
    $dateOfBirth: String
  ) {
    updateUser(
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      photo: $photo
      password: $password
      currentPassword: $currentPassword
      dateOfBirth: $dateOfBirth
    ) {
      ...CoreUserFields
    }
  }
`
